import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'dialog-component',
    templateUrl: 'dialog.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ]
})

export class DialogComponent {
    positiveKey: string = "Ok";
    negativeKey: string = "Cancel";
    title: string = "";
    content: string = "";
    showNegativeKey = true;
    contentList: Array<string> = [];
    isListContent: boolean = false;
    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data.positiveKey != undefined) {
            this.positiveKey = data.positiveKey;
        }

        if (data.negativeKey != undefined) {
            this.negativeKey = data.negativeKey;
        }
        if (data.showNegativeKey != undefined) {
            this.showNegativeKey = data.showNegativeKey;
        }
        this.title = data.title;
        this.content = data.content;
        this.contentList = data.contentList;
        this.isListContent = data.isListContent;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}